import { createFileRoute } from "@tanstack/react-router";
import { useSchoolLayoutData } from "#/modules/generic.user/use-schools";
import { RoosterWeekoverzicht } from "#/modules/les.planning/components/rooster-weekoverzicht";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/week/rooster/week",
)({ component: Weekoverzicht });

function Weekoverzicht() {
  const { school, schoolyear } = Route.useParams();
  const navigate = Route.useNavigate();
  const schoolName = useSchoolLayoutData()?.schoolName ?? school;
  return (
    <RoosterWeekoverzicht
      tenant={{ school, schoolyear }}
      schoolName={schoolName}
      onClose={() =>
        void navigate({
          to: "..",
          search: (prev) => prev,
          replace: true,
          resetScroll: false,
          viewTransition: true,
        })
      }
    />
  );
}
